import React, { memo } from "react";
import styles from "./RoofTypeItem.module.scss";
import { RoofType } from "../../../model/solar-recommendation-form/roofType";

type AddingProps = {
	isSelected: boolean;
	onAddRoofType: (category: RoofType) => void;
	onRemoveRoofType: (category: RoofType) => void;
};

type EditingProps = {
	category: RoofType;
	onEditAppliance: (category: RoofType) => void;
};

type Props = {
	category: RoofType;
	isAdded: boolean;
	addingProps?: AddingProps;
	editingProps?: EditingProps;
	onEditRoofHandler?: () => void;
	onDeleteAddRoofHandler?: () => void;
};

const RoofTypeItem: React.FC<Props> = memo((props: Props) => {
	const { category, isAdded, addingProps, editingProps } = props;

	function onChange() {
		if (addingProps!.isSelected) {
			addingProps!.onRemoveRoofType(category);
		} else {
			addingProps!.onAddRoofType(category);
		}
	}

	function onEdit() {
		// editingProps!.onEditAppliance({
		//     ...editingProps!.category, editingProps: {
		//         ...editingProps!.category.editingProps,
		//         editing: true,
		//         newAppliance: category
		//     }
		// })
	}

	return (
		<div className={styles.searchResultItem}>
			<div className={styles.searchResultItemInfo}>
				<div className={styles.division}>
					<img src={category?.iconUrl} alt={category.name} />
					{category.name}
				</div>
				{addingProps && (
					<>
						{!isAdded ? (
							<button className={`standardButton ${styles.button} ${addingProps!.isSelected && styles.removeButton}`} onClick={onChange}>
								{addingProps!.isSelected ? "Remove" : "Add"}
							</button>
						) : (
							<div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
						)}
					</>
				)}
				{editingProps && (
					<>
						{!isAdded ? (
							<button className={`standardButton ${styles.button}`} onClick={onEdit}>
								Change
							</button>
						) : (
							<div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
						)}
					</>
				)}
				{(props.onEditRoofHandler || props.onDeleteAddRoofHandler) && (
					<div className={styles.division}>
						{props.onEditRoofHandler && (
							<button className={`standardButton ${styles.submitButton}`} onClick={props.onEditRoofHandler}>
								Edit
							</button>
						)}
						{props.onDeleteAddRoofHandler && (
							<button className={`standardButton ${styles.submitButton}`} onClick={props.onDeleteAddRoofHandler}>
								Delete
							</button>
						)}
					</div>
				)}
			</div>
		</div>
	);
});

export default RoofTypeItem;
